import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-pt-footer',
  styleUrl: './pt-footer.css',
  templateUrl: './pt-footer.html',
})
export class PtFooter {}
